import React from 'react';
import {EncForm, EncInputField, EncCheckboxField, EncSelectField, withEncFormHandler} from '../../../../../../../../../components/hocs/form-validation';

const IDENTITY_TYPE_OPTIONS = [
    {key: 'MTLS_CERTIFICATE', value: 'MTLS_CERTIFICATE', text: 'mTLS Certificate'}
];

let EditIdentity = (props) => {
    const {formProperties, fieldProperties} = props;

    return (
        <EncForm formProperties={formProperties} fieldProperties={fieldProperties}>
            <EncSelectField
                id="identityType"
                label="user:user.identity.type"
                options={IDENTITY_TYPE_OPTIONS}
                validator={{
                    type: 'string',
                    rules: ['required']
                }}
            />
            <EncInputField
                id="value"
                label="user:user.identity.value"
                disabled={true}
            />
            <EncInputField
                id="description"
                label="user:user.identity.description"
            />
            <EncInputField
                id="notBefore"
                label="user:user.identity.not.before"
                disabled={true}
            />
            <EncInputField
                id="notAfter"
                label="user:user.identity.not.after"
                disabled={true}
            />
            <EncCheckboxField
                id="active"
                label="user:user.identity.active"
            />
        </EncForm>
    );
};

const FORM_VALIDATION_OPTIONS = {
    header: 'user:user.edit.identity',
    successMessage: 'user:user.identity.successfully.updated',
    validateOnChange: false,
    validateOnBlur: true
};

export default withEncFormHandler(FORM_VALIDATION_OPTIONS)(EditIdentity);
